import { render, staticRenderFns } from "./UserInputCard.vue?vue&type=template&id=44681997&scoped=true"
import script from "./UserInputCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInputCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./wellness-base.css?vue&type=style&index=0&id=44681997&prod&scoped=true&lang=css&external"
import style1 from "./UserInputCard.vue?vue&type=style&index=1&id=44681997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44681997",
  null
  
)

export default component.exports